export default () => {
    const form = $('form[name=contactform]')
    form.validate({
        errorClass: 'is-invalid',
        ignore: '',
        rules: {
            'name': {
                required: true,
            },
            'phone': {
                required: true,
                number: true,
                phoneUS: true
            },
            'email': {
                required: true,
                email: true,
            },
            'message': {
                required: true,
            },
            hiddenRecaptcha: {
                required: () => {
                    return grecaptcha.getResponse() === ''
                }
            }
        },
        highlight: (el, err) => {
            $(el).addClass('is-invalid')
        },
        unhighlight: (el, err) => {
            $(el).removeClass('is-invalid')
        },
        errorPlacement: (err, el) => {
            el.after(err)
        },
        submitHandler: (f, e) => {
            e.preventDefault()

            let name = $('input[name=name]').val()
            let email = $('input[name=email]').val()
            let phone = $('input[name=phone]').val()
            let message = $('textarea[name=message]').val()

            let msg = `<strong>Phone:</strong> ${phone}<br/><br/>${message}`

            let data = new FormData()
            data.append('to', 'taijimike@hotmail.com')
            // data.append('to', 'leowebguy@gmail.com')
            data.append('name', name || '')
            data.append('from', email)
            data.append('subj', 'FullCircle Form')
            data.append('msg', msg)

            $.post({
                url: 'https://api.gaunte.com/sendmail/',
                contentType: false,
                timeout: 0,
                processData: false,
                mimeType: 'multipart/form-data',
                data: data,
                success: function(r) {
                    r = $.parseJSON(r)
                    if (r.result) {
                        //console.log(`1 ${r.result}`)
                        form.trigger('reset')
                        $('#block-answer')
                            .html('<div class="alert alert-success"><p>message sent!</p></div>')
                            .fadeIn()
                            .delay(6000)
                            .fadeOut()

                        console.log(`%c${r.message}`, 'color:green')
                    } else {
                        //console.log(`2 ${r.result}`)
                        $('#block-answer')
                            .html('<div class="alert alert-danger"><p>' + r.message + '</p></div>')
                            .fadeIn()

                        console.log(`%c${r.message}`, 'color:#f28')
                    }
                },
                error: function(r) {
                    r = $.parseJSON(r)
                    //console.log(`3 ${r}`)
                    $('#block-answer')
                        .html('<div class="alert alert-danger"><p>' + r.message + '</p></div>')
                        .fadeIn()

                    console.log(`%c${r.message}`, 'color:#f28')
                }
            })
        },
    })

    function recaptchaCallback() {
        $('#hiddenRecaptcha').valid()
    }
};
